module.exports = __webpack_public_path__ + "static/media/eye.3d9803e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/example/maps/eye.jpg
// module id = 369
// module chunks = 0